module.exports = __webpack_public_path__ + "static/media/4.2ed7e671.jpg";